export const POST_TEMPLATE = "POST_TEMPLATE";
export const GET_TEMPLATE = "GET_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const GET_TEMPLATE_BY_DESIGN = "GET_TEMPLATE_BY_DESIGN";
export const SAVE_SETTINGS_REQUIRED = 'SAVE_SETTINGS_REQUIRED';
export const SAVE_SETTINGS_OPTIONAL = 'SAVE_SETTINGS_OPTIONAL';
